import {Badge, Flex} from "@chakra-ui/react";

const StatusBadge = ({status, region}) => {
    const options = {
        'new': {
            title: 'New',
            colorScheme: 'purple'
        },
        'draft': {
            title: 'Draft',
            colorScheme: 'blue'
        },
        'in_progress': {
            title: 'In Progress',
            colorScheme: 'pink'
        },
        'complete': {
            title: 'Complete',
            colorScheme: 'green'
        }
    }

    const regionOptions = {
        'asia': {
            title: 'Asia',
            colorScheme: 'purple'
        },
        'australia': {
            title: 'Australia',
            colorScheme: 'blue'
        },
        'north_america': {
            title: 'North America',
            colorScheme: 'pink'
        },
        'europe': {
            title: 'Europe',
            colorScheme: 'green'
        }
    }

    const statusDetails = options[status];
    const regionDetails = regionOptions[region];

    return (
        <>
            {(statusDetails !== undefined && regionDetails !== undefined) && (
                <Flex gap={2}>
                    <Badge colorScheme={statusDetails.colorScheme} width={"fit-content"} variant="solid">
                        {statusDetails.title}
                    </Badge>
                    <Badge colorScheme={regionDetails.colorScheme} width={"fit-content"} variant="solid">
                        {regionDetails.title}
                    </Badge>
                </Flex>


            )}
        </>
    );
}

export default StatusBadge;
